import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import Modal from "react-modal";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";
import ICatalogItemPickedDTO from "../../../models/DTO/ICatalogItemPickedDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetPickListDTO from "../../../models/DTO/IGetPickListDTO";
import IOnGetPickListDTO from "../../../models/DTO/IOnGetPickListDTO";
import IOnUpdatePickListDTO from "../../../models/DTO/IOnUpdatePickListDTO";
import IOnUpdatePickListLockDTO from "../../../models/DTO/IOnUpdatePickListLockDTO";
import IUpdatePickListDTO from "../../../models/DTO/IUpdatePickListDTO";
import IUpdatePickListLockDTO from "../../../models/DTO/IUpdatePickListLockDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IAction from "../../../models/IAction";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ICatalog_Item from "../../../models/ICatalog_Item";
import INotification from "../../../models/INotification";
import IOrder from "../../../models/IOrder";
import IOwTableCols from "../../../models/IOwTableCols";
import IPick_List from "../../../models/IPick_List";
import IPick_List_Catalog_Item_Detail from "../../../models/IPick_List_Catalog_Item_Detail";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import PickListRowStepEnum from "../../../models/PickListRowStepEnum";
import SortOrderEnum from "../../../models/SortOrderEnum";
import UserTypesEnum from "../../../models/UserTypesEnum";
import UserService from "../../../services/UserService";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import { CatalogItemLotAssignmentDetailView } from "../../shared/CatalogItemLotAssignmentDetailView/CatalogItemLotAssignmentDetailView";
import OwActionBar from "../../shared/OwActionBar/OwActionBar";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import { OwItemPickStatus } from "../../shared/OwItemPickStatus/OwItemPickStatus";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwPrintButton from "../../shared/OwPrintButton/OwPrintButton";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwToggle from "../../shared/OwToggle/OwToggle";
import PackingListSidebar from "../PackingListSidebar/PackingListSidebar";
import PickListDetailFilter from "../PickListDetailFilter/PickListDetailFilter";
import PickListItemDetail from "../PickListItemDetail/PickListItemDetail";
import "./PickListDetail.scss";
import CatalogItemService from "../../../services/CatalogItemService";
import { Socket } from "socket.io-client";
import { CatalogItemDescription } from "../../shared/CatalogItemDescription/CatalogItemDescription";
import { SearchSection } from "../../shared/SearchSection/SearchSection";

type Props = {
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    vendorModel: IVendorModel;
    supplierModel: ISupplierModel;
    history: any;
    match: any;
    location: any;
    /**
     * @deprecated
     */
    toggleMenu: () => void;
};

type State = {
    crumbs: IBreadcrumbs[];
    pickListGuid: string;
    pickList: IPick_List;
    filteredItems: IPick_List_Catalog_Item_Detail[];
    originalItems: IPick_List_Catalog_Item_Detail[];
    sortCol: string;
    sortOrder: SortOrderEnum;
    isDataFetching: boolean;
    isInitialData: boolean;
    cols: IOwTableCols[];
    detailViewCols: IOwTableCols[];
    totalPicked: number;
    hasUnsavedChanges: boolean;
    isFinalizeActive: boolean;
    isSaveActive: boolean;
    actions: IAction[];
    sortOrderDetail: "SKU" | "LOC" | "STATUS" | "";
    scanMode: boolean;
    capturedScanValue: string;
    modalComponent: any;
    modalIsOpen: boolean;
    readOnly: boolean;
    allowIncompletePick: boolean;
    issueItems: { [key: string]: boolean };
};

class PickListDetail extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            crumbs: [
                { title: "Pick Lists", url: "/pick_lists" },
                { title: "Detail", url: "/pick_lists/:guid" },
            ],
            pickListGuid: this.props.match.params.guid,
            pickList: {} as IPick_List,
            filteredItems: [],
            originalItems: [],
            sortCol: "sku",
            sortOrder: SortOrderEnum.ASC,
            isDataFetching: false,
            isInitialData: true,
            cols: [],
            detailViewCols: [],
            totalPicked: 0,
            hasUnsavedChanges: false,
            isFinalizeActive: false,
            isSaveActive: false,
            actions: [
                {
                    name: "copy_all_qty_to_picked",
                    fn: this.copyAllQtyToPicked,
                    leftIconClass: "fad fa-copy",
                    disabledFn: () => {
                        return false;
                    },
                },
            ],
            sortOrderDetail: "",
            scanMode: !!this.props.supplierModel.pick_list_scan_mode_active,
            capturedScanValue: "",
            modalComponent: null,
            modalIsOpen: false,
            readOnly: false,
            allowIncompletePick: false,
            issueItems: {},
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.OrderOnGetPickList, this.onGetPickList);
        this.props.socket.on(EndpointsEnum.OrderOnUpdatePickList, this.onUpdatePickList);
        this.props.socket.on(EndpointsEnum.OrderOnUpdatePickListLock, this.onUpdatePickListLock);

        const tableCols: IOwTableCols[] = [
            {
                className: "w-1r",
                isActionsCol: true,
                title: "",
                valueProp: "",
            },
            {
                className: "text-end w-8r",
                title: "qty",
                valueProp: "Pick_List_Catalog_Item_Map",
                valueSubProp: "qty_to_pick",
                isNumberFormat: true,
            },
            {
                className: "w-10r text-center-print",
                title: "qty_picked",
                valueProp: "",
                renderFn: this.qtyPickedRenderFn,
                renderFnEmitsRow: true,
            },
            {
                title: "sku",
                valueProp: "sku",
                isSortable: true,
                sortFn: this.sortPickList,
                sortOrderFn: () => {
                    return this.state.sortOrder;
                },
            },
            {
                title: "description",
                valueProp: "description",
                className: "pre-wrap",
                renderFn: this.renderDescriptionFn,
                renderFnEmitsRow: true,
            },
        ];

        if (this.props.supplierModel.has_pick_list_row_steps) {
            tableCols.splice(3, 0, {
                title: "step",
                valueProp: "row_step_id",
                renderFn: this.rowStepRenderFn,
                renderFnEmitsRow: true,
                className: "w-10r",
            });
        }

        this.setState({
            cols: tableCols,
            detailViewCols: [
                {
                    className: "w-2pt25r",
                    isActionsCol: true,
                    title: "",
                    valueProp: "",
                },
                {
                    className: "text-end w-8r",
                    title: "",
                    valueProp: "",
                },
                {
                    className: "w-10r text-center-print",
                    title: "qty_picked",
                    valueProp: "",
                    renderFn: this.qtyPickedRenderFn,
                    renderFnEmitsRow: true,
                },
                {
                    className: "w-15r",
                    title: "sku",
                    valueProp: "sku",
                },
                {
                    className: "w-15r",
                    title: "manufacturer",
                    valueProp: "manufacturer",
                },
                {
                    title: "description",
                    valueProp: "description",
                },
            ],
        });

        this.getPickList();
        document.addEventListener("keydown", this.keyboardListener);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.OrderOnGetPickList, this.onGetPickList);
        this.props.socket.removeListener(EndpointsEnum.OrderOnUpdatePickList, this.onUpdatePickList);
        this.props.socket.removeListener(EndpointsEnum.OrderOnUpdatePickListLock, this.onUpdatePickListLock);
        document.removeEventListener("keydown", this.keyboardListener);
    }

    copyAllQtyToPicked = () => {
        if (this.state.pickList && this.state.pickList.Catalog_Items) {
            const catalogItems = this.state.pickList.Catalog_Items;

            for (const catalogItem of catalogItems) {
                if (catalogItem.Pick_List_Catalog_Item_Map) {
                    const pickListItem = catalogItem.Pick_List_Catalog_Item_Map;

                    pickListItem.qty_picked = pickListItem.qty_to_pick;
                }
            }

            // Also update filteredItems to keep them in sync
            const filteredItems = this.state.filteredItems;
            for (const catalogItem of filteredItems) {
                if (catalogItem.Pick_List_Catalog_Item_Map) {
                    const pickListItem = catalogItem.Pick_List_Catalog_Item_Map;

                    pickListItem.qty_picked = pickListItem.qty_to_pick;
                }
            }

            const pickList = this.state.pickList;
            pickList.Catalog_Items = catalogItems;

            const totalPicked = this.getTotalPicked(this.state.pickList);

            this.setState({
                pickList,
                filteredItems,
                totalPicked,
                hasUnsavedChanges: true,
            });
        }
    };

    showChevronFn = (row: ICatalog_Item): boolean => {
        if (this.props.supplierModel.assign_lots_in_pick_list && this.props.supplierModel.has_lots) {
            if (row.has_lots) {
                return true;
            } else {
                return false;
            }
        } else {
            return !!row.has_alternate_sourcing;
        }
    };

    handleSortDetailChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state, () => {
            this.sortBy();
        });
    };

    handleChange = (e: any, index: number, isDetailView?: boolean, parentRowIndex?: number) => {
        let value = e.target.value;
        const name = e.target.name;

        const filteredItems = this.state.filteredItems;

        if (!_.isNil(parentRowIndex)) {
            const parentItem = filteredItems[parentRowIndex];

            const productSources = filteredItems[parentRowIndex].Product_Sources;

            if (productSources) {
                const pickListCatalogItemMap = productSources[index].Pick_List_Catalog_Item_Map;

                let currentTotal = 0;

                for (const sourceItem of productSources) {
                    if (sourceItem.Pick_List_Catalog_Item_Map.qty_picked && sourceItem.guid !== productSources[index].guid) {
                        currentTotal += Number(sourceItem.Pick_List_Catalog_Item_Map.qty_picked);
                    }
                }

                if (Number(value) + Number(currentTotal) <= parentItem.Pick_List_Catalog_Item_Map.qty_to_pick) {
                    if (value < 0) {
                        value = 0;
                    }

                    // @ts-expect-error
                    pickListCatalogItemMap[name] = value;
                }
                console.log("parentRowIndex", parentRowIndex, filteredItems[index]);
                // parent item total amount is needed, along with the other children items.

                let updatedPickTotals = 0;

                for (const sourceItem of productSources) {
                    if (sourceItem.Pick_List_Catalog_Item_Map.qty_picked) {
                        updatedPickTotals += Number(sourceItem.Pick_List_Catalog_Item_Map.qty_picked);
                    }
                }

                filteredItems[parentRowIndex].Pick_List_Catalog_Item_Map.qty_picked = updatedPickTotals;
            }
        } else {
            // @ts-expect-error
            const pickListCatalogItemMap = filteredItems[index].Pick_List_Catalog_Item_Map;

            if (value <= pickListCatalogItemMap.qty_to_pick) {
                if (value < 0) {
                    value = 0;
                }

                // @ts-expect-error
                filteredItems[index].Pick_List_Catalog_Item_Map[name] = value;
            }
        }

        let totalPicked = 0;

        for (const catalogItem of filteredItems) {
            // @ts-expect-error
            totalPicked += Number(catalogItem.Pick_List_Catalog_Item_Map.qty_picked);
        }

        this.setState({
            hasUnsavedChanges: true,
            filteredItems,
            totalPicked,
        });
    };

    handleDetailChange = (e: any, index: number) => {};

    rowStepRenderFn = (item: IPick_List_Catalog_Item_Detail, rowIndex: number, isDetailView?: boolean, parentRowIndex?: number) => {
        if (this.state.pickList.is_locked) {
            return (
                <div className={""}>
                    <OwLabel title={item.Pick_List_Catalog_Item_Map.Pick_List_Row_Step?.name.toLowerCase()} />
                </div>
            );
        } else {
            const stepOptions = [
                { title: "gathered", value: PickListRowStepEnum.GATHERED },
                { title: "filled", value: PickListRowStepEnum.FILLED },
                { title: "boxed", value: PickListRowStepEnum.BOXED },
            ];

            return (
                <div>
                    <OwSelectOption
                        fn={(e: any) => {
                            this.handleChange(e, rowIndex, isDetailView, parentRowIndex);
                        }}
                        name={"row_step_id"}
                        selectedOption={item?.Pick_List_Catalog_Item_Map}
                        selectedOptionProp={"row_step_id"}
                        options={stepOptions}
                        valueProp={"value"}
                        titleProp={"title"}
                        translateTitle={true}
                    />
                </div>
            );
        }
    };

    renderDescriptionFn = (item: IPick_List_Catalog_Item_Detail, rowIndex: number, isDetailView?: boolean, parentRowIndex?: number) => {
        const catalogItem = item;

        const description = <CatalogItemDescription catalogItem={catalogItem} />;

        return description;
    };

    qtyPickedRenderFn = (item: IPick_List_Catalog_Item_Detail, rowIndex: number, isDetailView?: boolean, parentRowIndex?: number) => {
        if (this.state.pickList.is_locked) {
            return <div className={"text-center"}>{item.Pick_List_Catalog_Item_Map.qty_picked}</div>;
        } else {
            return (
                <OwInputWrapper
                    key={item.guid}
                    type={"number"}
                    value={item.Pick_List_Catalog_Item_Map.qty_picked || 0}
                    fn={(e: any) => {
                        this.handleChange(e, rowIndex, isDetailView, parentRowIndex);
                    }}
                    name={"qty_picked"}
                    className={"text-end"}
                    disabled={item.has_alternate_sourcing}
                />
            );
        }
    };

    getFilteredItems = (pickList: IPick_List) => {
        const filteredItems = _.filter(pickList.Catalog_Items, (item) => {
            if (!item.is_alternate_source) {
                return true;
            } else {
                if (item.is_customer_orderable && !item.Pick_List_Catalog_Item_Map.parent_catalog_item_id) {
                    return true;
                } else {
                    return false;
                }
            }
        });

        return filteredItems;
    };

    getTotalPicked = (pickList: IPick_List): number => {
        const filteredItems = this.getFilteredItems(pickList);

        let totalPicked = 0;

        for (const item of this.state.pickList.Catalog_Items || []) {
            if (item.is_alternate_source) {
                for (const filteredItem of filteredItems) {
                    if (filteredItem.has_alternate_sourcing && filteredItem.id === item.Pick_List_Catalog_Item_Map.parent_catalog_item_id) {
                        if (!filteredItem.Product_Sources) {
                            filteredItem.Product_Sources = [];
                        }

                        filteredItem.Product_Sources.push(item);
                    }
                }

                if (item.is_customer_orderable && !item.Pick_List_Catalog_Item_Map.parent_catalog_item_id) {
                    totalPicked += Number(item.Pick_List_Catalog_Item_Map.qty_picked);
                }
            } else {
                totalPicked += Number(item.Pick_List_Catalog_Item_Map.qty_picked);
            }
        }

        return totalPicked;
    };

    getPickList = () => {
        const payload: IGetPickListDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            pickListGuid: this.state.pickListGuid,
        };

        this.props.socket.emit("getPickList", payload);

        this.setState({
            isDataFetching: true,
            hasUnsavedChanges: false,
        });
    };

    onGetPickList = (data: IOnGetPickListDTO) => {
        const filteredItems = this.getFilteredItems(data.pickList);

        const totalPicked = this.getTotalPicked(data.pickList);

        document.title = `Orderwerks >> Pick Lists >> ${data.pickList.name}`;

        let readOnly = false;

        if (data.pickList.is_locked) {
            readOnly = true;
        }

        this.setState(
            {
                filteredItems,
                pickList: data.pickList,
                totalPicked,
                isInitialData: false,
                isDataFetching: false,
                readOnly,
            },
            () => {
                this.sortBy();
            }
        );
    };

    updatePickList = () => {
        const catalogItemsPicked: ICatalogItemPickedDTO[] = this.state.pickList.Catalog_Items!.map((item) => {
            return {
                id: item.Pick_List_Catalog_Item_Map.id,
                qty_picked: item.Pick_List_Catalog_Item_Map.qty_picked,
                catalog_item_id: item.id,
                parent_item_id: item.Pick_List_Catalog_Item_Map.parent_catalog_item_id,
                row_step_id: item.Pick_List_Catalog_Item_Map.row_step_id,
            } as ICatalogItemPickedDTO;
        });

        const payload: IUpdatePickListDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            pickListGuid: this.state.pickListGuid,
            catalogItemsPicked,
        };

        this.props.socket.emit(EndpointsEnum.OrderUpdatePickList, payload);

        this.setState({
            isSaveActive: true,
        });
    };

    onUpdatePickList = (data: IOnUpdatePickListDTO) => {
        this.setState(
            {
                isSaveActive: false,
            },
            () => {
                this.getPickList();
            }
        );
    };

    savePickList = () => {
        this.updatePickList();
    };

    /**
     * Determine if a pick list can be finalized by seeing if each item has the total qty. between the picked
     * item and the issue qty.
     *
     * Returns {[key: string]: boolean}, where true has issue, false doesn't
     */
    verifyPickListCanBeFinalized = (): { issueItems: { [key: string]: boolean }; hasIssues: boolean } => {
        const issueItems: { [key: string]: boolean } = {};

        let hasIssues = false;

        if (!this.state.allowIncompletePick) {
            if (this.state.pickList.Catalog_Items) {
                for (const item of this.state.pickList.Catalog_Items) {
                    if (
                        (item.Pick_List_Catalog_Item_Map.qty_picked || 0) + (item.Pick_List_Catalog_Item_Map.issue_qty || 0) !==
                        item.Pick_List_Catalog_Item_Map.qty_to_pick
                    ) {
                        issueItems[item.guid] = true;
                        hasIssues = true;
                    } else {
                        issueItems[item.guid] = false;
                    }
                }
            }
        }

        return { issueItems, hasIssues };
    };

    unlockPickList = () => {
        const payload: IUpdatePickListLockDTO = {
            pickListGuid: this.state.pickList.guid,
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            isLocked: false,
        };

        this.props.socket.emit(EndpointsEnum.OrderUpdatePickListLock, payload);

        this.setState({
            isFinalizeActive: true,
            issueItems: {},
        });
    };

    updatePickListLock = () => {
        const { issueItems, hasIssues } = this.verifyPickListCanBeFinalized();

        if (!hasIssues) {
            const payload: IUpdatePickListLockDTO = {
                pickListGuid: this.state.pickList.guid,
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                isLocked: true,
            };

            this.props.socket.emit(EndpointsEnum.OrderUpdatePickListLock, payload);

            this.setState({
                isFinalizeActive: true,
                issueItems: {},
            });
        } else {
            this.setState(
                {
                    issueItems,
                },
                () => {
                    const notification: INotification = {
                        message: "incomplete_pick_verify_marked_rows",
                        position: NotificationPositionEnum.bc,
                        level: NotificationLevelEnum.error,
                    };

                    this.props.notifyFn(null, notification);
                }
            );
        }
    };

    onUpdatePickListLock = (data: IOnUpdatePickListLockDTO) => {
        this.setState(
            {
                isFinalizeActive: false,
            },
            () => {
                this.getPickList();
            }
        );
    };

    sortPickList = (sortCol: string, sortOrder: SortOrderEnum) => {
        // sort the sku col
        let filteredItems = this.state.filteredItems;

        let catalogItems = _.sortBy(
            filteredItems,
            (item) => {
                // @ts-expect-error
                return item[sortCol];
            },
            sortOrder
        );

        // console.log("orderItems", orderItems, sortCol, sortOrder);

        if (filteredItems && catalogItems) {
            if (sortOrder === SortOrderEnum.DESC) {
                catalogItems = catalogItems.reverse();
            }

            filteredItems = catalogItems;

            this.setState({
                filteredItems,
                sortOrder,
                sortCol,
            });
        }
    };

    cancel = (refreshData?: boolean) => {
        this.props.toggleSidebar(false);
    };

    createPackingLists = () => {
        const sidebarComponent = (
            <PackingListSidebar
                pickList={this.state.pickList}
                notifyFn={this.props.notifyFn}
                socket={this.props.socket}
                cancel={this.cancel}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );

        this.props.setSidebarComponent(sidebarComponent);
        this.props.toggleSidebar(true);
    };

    viewItemDetail = (item: IPick_List_Catalog_Item_Detail) => {
        this.openItem(item);
        // this.props.history.push(`/pick_lists/${this.state.pickListGuid}/item/${item.Pick_List_Catalog_Item_Map.id}`);
    };

    doSearch = (sku?: string, loc?: string) => {
        const pickList = this.state.pickList;
        const originalItems = this.state.originalItems.length ? this.state.originalItems : this.state.pickList.Catalog_Items || [];
        const pickListItems: IPick_List_Catalog_Item_Detail[] = [];

        if (originalItems.length) {
            for (const item of originalItems) {
                if (sku) {
                    if (item.sku.indexOf(sku) > -1) {
                        pickListItems.push(item);
                        continue;
                    }
                }

                if (loc) {
                    let found = false;

                    for (const warehouseMap of item.Warehouse_Catalog_Items_Maps || []) {
                        if (
                            (warehouseMap.row && warehouseMap.row.indexOf(loc) > -1) ||
                            (warehouseMap.bin && warehouseMap.bin.indexOf(loc) > -1)
                        ) {
                            found = true;
                            break;
                        }
                    }

                    if (found) {
                        pickListItems.push(item);
                    }
                }
            }

            pickList.Catalog_Items = pickListItems;
        }

        this.setState({
            pickList,
            originalItems,
        });
    };

    resetSearch = () => {
        const pickList = this.state.pickList;

        if (this.state.originalItems.length) {
            pickList.Catalog_Items = this.state.originalItems;

            this.setState({
                pickList,
            });
        }
    };

    sortBy = () => {
        const pickList = this.state.pickList;
        let pickListItems = pickList.Catalog_Items || [];

        if (this.state.sortOrderDetail === "SKU") {
            pickListItems = _.orderBy(pickListItems, "sku", this.state.sortOrder);
        } else if (this.state.sortOrderDetail === "LOC") {
            // Do nothing?
        } else if (this.state.sortOrderDetail === "STATUS") {
            pickListItems = _.orderBy(
                pickListItems,
                (item) => {
                    return item.Pick_List_Catalog_Item_Map.status_id;
                },
                this.state.sortOrder
            );
        }

        pickList.Catalog_Items = pickListItems;

        this.setState({
            pickList,
        });
    };

    toggleSortOrder = () => {
        let sortOrder = this.state.sortOrder;

        if (sortOrder === SortOrderEnum.ASC) {
            sortOrder = SortOrderEnum.DESC;
        } else {
            sortOrder = SortOrderEnum.ASC;
        }

        this.setState(
            {
                sortOrder,
            },
            () => {
                this.sortBy();
            }
        );
    };

    keyboardListener = (e: KeyboardEvent) => {
        if (this.state.scanMode) {
            console.log("keyboardListener: ", e);
            // ignore the following key events
            switch (e.key) {
                case "Shift":
                case "Unidentified":
                    return;

                case "Enter":
                    this.processCapturedScanValue();
                    return;
            }

            this.setState({
                capturedScanValue: `${this.state.capturedScanValue}${e.key}`,
            });
        }
    };

    processCapturedScanValue = () => {
        const capturedScanValue = this.state.capturedScanValue;

        console.log("processCapturedScanValue: ", capturedScanValue);

        if (capturedScanValue.length) {
            // process the scan

            this.setState(
                {
                    capturedScanValue: "",
                },
                () => {
                    const notification: INotification = {
                        message: "scan_captured",
                        level: NotificationLevelEnum.success,
                        position: NotificationPositionEnum.bc,
                    };

                    this.props.notifyFn(null, notification);

                    let found = false;

                    if (this.state.pickList?.Catalog_Items && !this.state.modalIsOpen) {
                        for (const item of this.state.pickList.Catalog_Items) {
                            if (item.sku === capturedScanValue || item.upc === capturedScanValue) {
                                this.openItem(item, true);
                                found = true;
                                // this.props.history.push(`/pick_lists/${this.state.pickListGuid}/item/${item.Pick_List_Catalog_Item_Map.id}`);
                                break;
                            }
                        }
                    }

                    if (!found) {
                        const notification: INotification = {
                            message: "item_not_in_pick_list",
                            level: NotificationLevelEnum.error,
                            position: NotificationPositionEnum.bc,
                        };

                        this.props.notifyFn(null, notification);
                    }
                    // this.search();
                }
            );
        } else {
            // error processing the captured scan value

            const notification: INotification = {
                message: "error_capturing_scan",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            };

            this.props.notifyFn(null, notification);
        }
    };

    toggleScanMode = () => {
        this.setState({
            scanMode: !this.state.scanMode,
        });
    };

    openItem = (item: IPick_List_Catalog_Item_Detail, incrementOnLoad?: boolean) => {
        const modalComponent = (
            <PickListItemDetail
                supplierModel={this.props.supplierModel}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                setActivityIndicator={this.props.setActivityIndicator}
                item={item}
                closeFn={this.closeModal}
                pickList={this.state.pickList}
                scanMode={this.state.scanMode}
                incrementOnLoad={incrementOnLoad}
                readOnly={this.state.readOnly}
                history={this.props.history}
                match={this.props.match}
                location={this.props.location}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    closeModal = (refreshData?: boolean, openDiffItem?: IPick_List_Catalog_Item_Detail) => {
        this.setState(
            {
                modalIsOpen: false,
                modalComponent: null,
            },
            () => {
                if (refreshData) {
                    if (!openDiffItem) {
                        this.getPickList();
                    } else {
                        this.openItem(openDiffItem);
                    }
                } else {
                    if (openDiffItem) {
                        this.openItem(openDiffItem);
                    }
                }
            }
        );
    };

    toggleAllowIncompletePick = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    lotsDetailView = (row: ICatalog_Item, index: number) => {
        const pickListCatItemMap = this.state.filteredItems[index];

        return (
            <CatalogItemLotAssignmentDetailView
                catalogItem={row}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                socket={this.props.socket}
                pickList={this.state.pickList}
                notifyFn={this.props.notifyFn}
                pickListCatItemDetail={pickListCatItemMap}
            />
        );
    };

    rowHasDetailView = (row: ICatalog_Item): boolean => {
        return !!row.has_lots;
    };

    detailViewRowOverride = (row: any, parentRowIndex?: number | undefined): boolean => {
        return true;
    };

    render() {
        const ordersDetail = _.map(this.state.pickList.Orders, (order: IOrder, index: number) => {
            return (
                <div key={index} className={"col-12 col-md-2"}>
                    <i className={"far fa-square"} /> <Link to={`/orders/${order.guid}/entry`}>{order.name}</Link> - {order.Vendor?.name}
                </div>
            );
        });

        const orders = (
            <div className={""}>
                <div className={"row d-flex"}>{ordersDetail}</div>
            </div>
        );

        const catalogItems = this.state.pickList.Catalog_Items || [];

        let totalQtyToPick = 0;

        catalogItems.forEach((item) => {
            totalQtyToPick += Number(item.Pick_List_Catalog_Item_Map.qty_to_pick);
        });

        const sortOptions = [
            { title: "sku", value: "SKU" },
            { title: "status", value: "STATUS" },
            { title: "loc", value: "LOC" },
        ];

        return (
            <div className="PickListDetail">
                <Breadcrumbs crumbs={this.state.crumbs} />

                <div className="row mt-2">
                    <div className="col-12 d-flex align-items-center justify-items-center mb-3">
                        <OwTitle
                            className={"me-3"}
                            title={this.state.pickList.name}
                            leftIconName="fad fa-hand-holding-box d-print-none"
                            disableTranslation={true}
                        />
                        <div className={"d-flex flex-column ms-auto d-print-none"}>
                            <div>
                                <OwLabel title={"scan_mode"} />
                            </div>
                            <OwToggle fn={this.toggleScanMode} name={"scan_mode"} label={""} active={this.state.scanMode} />
                        </div>
                    </div>

                    <div className={"col-12 text-end"}>
                        {!this.state.isInitialData && !this.state.pickList.is_locked ? (
                            <div className={"mb-4"}>
                                <div>
                                    <OwButton
                                        className={"btn-primary d-print-none me-2"}
                                        title={"save"}
                                        fn={this.savePickList}
                                        active={this.state.isSaveActive}
                                        disableOnActive={true}
                                    />
                                    <OwButton
                                        className={"btn-danger d-print-none"}
                                        leftIconClass={"fad fa-lock"}
                                        title={"finalize"}
                                        fn={this.updatePickListLock}
                                        active={this.state.isFinalizeActive}
                                        disableOnActive={true}
                                        disabled={this.state.hasUnsavedChanges}
                                    />
                                </div>

                                <div className={"mt-2 d-none d-md-block"}>
                                    <OwCheckbox
                                        truthyVal={true}
                                        falsyVal={false}
                                        name={"allowIncompletePick"}
                                        checked={this.state.allowIncompletePick}
                                        fn={this.toggleAllowIncompletePick}
                                        label={"allow_incomplete_pick"}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className={"mb-4"}>
                                {this.props.userModel.isSupplierUser && this.props.userModel?.userType?.id === UserTypesEnum.ADMIN ? (
                                    <OwButton
                                        className={"btn-danger d-print-none"}
                                        leftIconClass={"fad fa-unlock"}
                                        title={"unlock"}
                                        fn={this.unlockPickList}
                                        active={this.state.isFinalizeActive}
                                        disableOnActive={true}
                                        disabled={this.state.hasUnsavedChanges}
                                    />
                                ) : null}
                            </div>
                        )}

                        <div className={"d-print-none mb-4"}>
                            <div className={"mb-3 d-none d-md-block"}>
                                <OwPrintButton />
                            </div>

                            <div>
                                {this.state.pickList.is_locked ? (
                                    <OwButton
                                        title={"create_packing_list"}
                                        leftIconClass={"fad fa-file-plus"}
                                        fn={this.createPackingLists}
                                    />
                                ) : (
                                    <OwLabel title={"finalize_to_create_packing_lists"} className={"text-danger"} />
                                )}
                            </div>
                            <div>
                                <OwLabel title={"updated_at"} className={"me-2"} noBottomMargin={true} />
                                {UserService.parseDate(this.state.pickList.updated_at)}
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.hasUnsavedChanges ? (
                    <div>
                        <OwLabel title={"pending_changes_save_first"} className={"text-danger"} />
                    </div>
                ) : null}

                <div className={"d-none d-md-block d-print-flex flex-column"}>
                    <OwTitle className={"mt-3"} title={"orders"} tag={"h5"} isBold={true} />

                    {orders}
                </div>

                <div className={"mt-2 mb-2 d-print-none"}>
                    <SearchSection>
                        <PickListDetailFilter searchFn={this.doSearch} resetSearch={this.resetSearch} />
                    </SearchSection>
                </div>

                <div className={"d-block row mb-2 d-print-none"}>
                    <div className={"col-12 d-flex"}>
                        <div className={"ms-auto"}>
                            <OwSelectOption
                                options={sortOptions}
                                titleProp={"title"}
                                fn={this.handleSortDetailChange}
                                name={"sortOrderDetail"}
                                valueProp={"value"}
                                translateTitle={true}
                            />
                        </div>
                        <div>
                            <OwButton
                                centerIconClass={this.state.sortOrder === SortOrderEnum.ASC ? "fas fa-arrow-up" : "fas fa-arrow-down"}
                                fn={this.toggleSortOrder}
                                minWidth={50}
                                disabled={!this.state.sortOrderDetail.length}
                            />
                        </div>
                    </div>
                </div>

                {this.state.pickList.is_locked ? null : (
                    <div className={"d-none d-md-block d-print-none"}>
                        <OwActionBar
                            toggleSmallTable={() => {}}
                            colToggledFn={() => {}}
                            columns={{}}
                            hideColumnToggle={true}
                            hideTableTypeSelect={true}
                            actions={this.state.actions}
                        />
                    </div>
                )}

                <div className={"d-none d-md-none"}>
                    <OwTable
                        tableConfig={{
                            tableHasSort: true,
                            alignHeadersMiddle: true,
                            hasDetailView: true,
                            detailViewFullWidth: true,
                        }}
                        tableClassName={"table-print-view mb-1"}
                        columns={this.state.cols}
                        dataSet={this.state.filteredItems}
                        detailViewColumns={this.state.detailViewCols}
                        detailViewDataSetProp={"Catalog_Item"}
                        // detailViewDataSetSubProp={"Product_Sources"}
                        // detailViewInitialData={false}
                        // detailViewDataFetch={false}
                        // detailViewRowOverride={this.detailViewRowOverride}
                        // detailViewComponent={this.lotsDetailView}
                        // detailViewAlwaysVisible={!!this.props.supplierModel.has_lots}
                        // rowDetailViewFn={this.rowHasDetailView}
                        // detailViewTitle={"lots"}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isDataFetching}
                        initialData={this.state.isInitialData}
                    />
                </div>

                <div className={""}>
                    {(this.state.pickList.Catalog_Items || []).map((item) => {
                        return (
                            <div
                                key={item.guid}
                                className={"col-12 itemRow pb-2 pt-2 d-flex " + (this.state.issueItems[item.guid] ? "border-warning" : "")}>
                                <div className={"w-80"}>
                                    <div>
                                        <OwTitle
                                            className={"d-inline-flex text-primary pointer"}
                                            title={item?.name}
                                            tag={"h5"}
                                            disableTranslation={true}
                                            isUnderline={true}
                                            fn={() => {
                                                this.viewItemDetail(item);
                                            }}
                                        />
                                    </div>
                                    <div className={"text-small text-muted"}>{item?.sku}</div>
                                    <div>
                                        <OwLabel title={"qty"} postText={":"} className={"me-2"} />
                                        {item.Pick_List_Catalog_Item_Map.qty_to_pick}
                                    </div>
                                    {item.Warehouse_Catalog_Items_Maps?.length ? (
                                        <div>
                                            <OwLabel title={"loc"} postText={":"} className={"me-2"} />
                                            {(item.Warehouse_Catalog_Items_Maps || []).map((mapItem) => {
                                                return `${mapItem.Warehouse?.name || ""} ${mapItem.row || ""} ${mapItem.bin || ""}`;
                                            })}
                                        </div>
                                    ) : null}
                                    {item.Pick_List_Catalog_Item_Map.sub_catalog_item_id ? (
                                        <div>
                                            <OwLabel title={"sub"} leftIconClass={"fad fa-exchange"} postText={":"} className={"me-2"} />
                                            {item.Pick_List_Catalog_Item_Map.Substitution_Catalog_Item?.sku} -{" "}
                                            <OwLabel title={"qty"} postText={":"} className={"me-2"} />
                                            {item.Pick_List_Catalog_Item_Map.issue_qty}
                                        </div>
                                    ) : null}
                                </div>
                                <div className={"w-20"}>
                                    <div className={"mt-2 mb-2"}>
                                        <i
                                            className={
                                                "fa-lg fad fa-sticky-note " +
                                                (item?.Pick_List_Catalog_Item_Map.issue_note?.length ? "text-warning" : "")
                                            }
                                        />
                                    </div>
                                    <div>
                                        <OwItemPickStatus item={item} />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className={"row pb-2 d-none"}>
                    <div className={"col-12"}>
                        <div
                            className={"d-flex border-dark"}
                            style={{
                                borderStyle: "double",
                                borderBottom: "none",
                                borderLeft: "none",
                                borderRight: "none",
                            }}>
                            <div style={{ paddingRight: ".6rem" }} className={"w-3r text-end"}></div>
                            <div style={{ paddingRight: ".6rem" }} className={"w-8r text-end"}>
                                <NumericFormat value={totalQtyToPick} displayType={"text"} thousandSeparator={true} />
                            </div>
                            <div
                                style={{ paddingRight: ".6rem" }}
                                className={"w-10r  " + (this.state.pickList.is_locked ? "text-center-print text-center" : "text-end")}>
                                <NumericFormat value={this.state.totalPicked} displayType={"text"} thousandSeparator={true} />
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={(e: any) => {
                            this.closeModal();
                        }}
                        contentLabel="Orderwerks"
                        shouldCloseOnOverlayClick={false}
                        className={"modalFullContentClass"}
                        overlayClassName={"modalFullOverlayClass"}
                        style={{}}>
                        {this.state.modalComponent}
                    </Modal>
                </div>
            </div>
        );
    }
}

export default PickListDetail;
